import { Button, Field, OtpInput } from "@nabble/ui";
import type { FormEvent } from "react";
import type { OtpCode } from "../../../hooks/useOtpCode";

const TOTP_CODE_LENGTH = 6;

interface TotpCodeFormProps {
  totp: OtpCode;
  loading: boolean;
  error: string | null;
  onVerify: (code: string) => void;
}

/** Sign-in with the authenticator app: verifies as soon as the sixth digit is typed. */
export function TotpCodeForm({ totp, loading, error, onVerify }: TotpCodeFormProps): React.JSX.Element {
  const { code, setCode, shake } = totp;

  function onSubmit(e: FormEvent): void {
    e.preventDefault();
    if (code.length === TOTP_CODE_LENGTH) onVerify(code);
  }

  return (
    <form className="nb-auth-form" onSubmit={onSubmit}>
      <Field label="6-digit code" help="Open your authenticator app and type the Nabble Suite code." error={error ?? undefined}>
        <OtpInput key={shake} value={code} onChange={setCode} onComplete={onVerify} autoFocus shaking={shake > 0} disabled={loading} />
      </Field>
      <Button type="submit" label="Verify" size="lg" block loading={loading} disabled={code.length !== TOTP_CODE_LENGTH} />
    </form>
  );
}
